import * as marietta from '../../..';
import { ChangeItem } from '../../../view3d/webcad/ChangeItem';
import { Dialog } from '../../../core/view';
import { ThreeView, View3dGlobal } from '../../../view3d/webcad';
import { ChangeFittingItem } from '../../../view3d/webcad/ChangeFittingItem';
import MasterItemCollection from '../../collection/MasterItemCollection';
/**
 * 3Dーアイテムの３Dイメージ変更
 * 対象：家具、設備、エクステリア
 */
export default class ItemChangeDialog extends Dialog {
  public target: any = undefined;

  /**
   * コンストラクタ
   */
  // eslint-disable-next-line no-useless-constructor
  constructor(draggable: boolean, modal: boolean) {
    super(draggable, modal);
  }

  buildContent() {
    // ダイアログのコンテンツ生成
    const id = 'dialogItemChange';

    let title = '';
    // タイトル
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'jp': title = 'アイテム変更'; break;
      default: title = 'Item Change'; break;
    }

    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    let contents = '<div class="changeItemMenu">';
    contents = '<div class="itemChangeList"></div>';
    contents += '</div>';

    const footer = '';

    this.createDialog(id, title, contents, footer);

    this.createItemList();
    this.setEvent();
    this.updateCurrent();
  }

  /**
   * アイテムリストの生成
   */
  createItemList() {
    const alternatives = this.target.userData.attribute.alternative;
    const dir = View3dGlobal.shared.itemDir;
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;

    let contents = '';
    if (alternatives) {
      if (alternatives.length > 0) {
        contents += '<ul>';
        /* contents += `<li data-name=${this.target.userData.attribute.objectId} class="btnChangeItem">`;
        contents += `<button id="changeItem${String(0)}" data-itemid="0">`;
        contents += '<div class="imgBox">';
        contents += `<img src="${dir}${this.target.userData.attribute.thumbnail}" width="96" height="96"/>`;
        contents += '<div class="currentFrame"></div>';
        contents += '</button>';
        contents += '<p><span class="jp">ホワイトモデル</span><span class="en">White Model</span></p>';
        contents += '</div>';
        contents += '</li>'; */
        for (let i = 1; i <= alternatives.length; i += 1) {
          const alt = alternatives[i - 1];
          const imgPath = dir + alt.thumbnail;
          contents += `<li data-name=${alternatives[i - 1].id} class="btnChangeItem" data-itemid="${i}" data-item3did="${alt.id}">`;
          contents += `<button id="changeItem${String(i)}">`;
          contents += '<div class="imbBox">';
          if (ua.isMobile) contents += `<img src="${imgPath}" width="60" height="60"/>`;
          else contents += `<img src="${imgPath}" width="96" height="96"/>`;
          contents += '<div class="currentFrame"></div>';
          contents += '</button>';
          // contents += `<p><span class="jp">${alternatives[i - 1].name}</span><span class="en">${alternatives[i - 1].nameEn}</span></p>`;
          contents += '</div>';
          contents += '</li>';
        }
        contents += '</ul>';
      } else {
        contents = '<div class="noItemError">入れ替えるアイテムがありません。</div>';
      }
    }
    document.querySelector('#dialogItemChange .itemChangeList').innerHTML = contents;
    
    if (ua.isMobile) document.getElementById('dialogItemChange').classList.add('forSP');
  }

  /**
   * アイテム変更イベントの生成
   */
  setEvent() {
    document.querySelectorAll('#dialogItemChange .itemChangeList li').forEach((elem) => {
      elem.addEventListener('click', (e) => {
        const item3did = (<HTMLElement> e.currentTarget).getAttribute('data-item3did');
        new ChangeItem().changeItem(this.target, item3did);

        // 変更フラグを立てる
        marietta.webcad.WebCADGlobal.webcad2Dmanager.isChanged = true;

        // ダイアログを閉じる
        super.closeEvent();
      });
    });
  }

  /**
     * 閉じるボタンが押された
     */
  close = () => {
    // ThreeView.get().controller.description();

    ThreeView.get().unSelectedObject();
    this.closeEvent();

    // ThreeView.get().controller.description();
  }

  /**
   * override
   */
  closeEvent() {
    super.closeEvent();
  }

  /*
  * カレント表示の追加
  */
  updateCurrent() {
    const id = this.target.userData.modelInfo._idthreed ? this.target.userData.modelInfo._idthreed : this.target.userData.modelInfo._id;
    const element = document.querySelector(`#dialogItemChange .itemChangeList [data-name='${id}']`);
    if (element) element.closest('li').classList.add('is-active');
  }
}
